(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/utils/assets/javascripts/user.js') >= 0) return;  svs.modules.push('/components/accountservices/utils/assets/javascripts/user.js');

'use strict';

svs = svs || {};
svs.accountservices = svs.accountservices || {};
svs.accountservices.utils = svs.accountservices.utils || {};
const log = new svs.core.log.Logger('components:accountservices:utils:user');
class User {
  constructor() {
    this.userData = null;
  }
  saveToSessionStorage(data) {
    const dataToStore = this.getUserDataFromCustomizedSettings(data);
    try {
      sessionStorage.setItem('user', btoa(JSON.stringify(dataToStore)));
    } catch (e) {
      log.info("Error trying to set sessionStorage ".concat(e));
    }
  }
  async getUserData() {
    let userData = this.userData;
    if (!userData) {
      let storedData;
      try {
        storedData = sessionStorage.getItem('user');
      } catch (e) {
        log.info("Error trying to access sessionStorage ".concat(e));
      }
      if (storedData) {
        userData = JSON.parse(atob(storedData));
      } else {
        userData = await this.getAndSaveCustomizedSettings();
      }
    }
    this.userData = userData;
    return userData;
  }
  async getAge() {
    const userData = await this.getUserData();
    const birthDate = userData.birthDate;
    if (birthDate) {
      return dateFns.differenceInYears(new Date(), dateFns.parseISO(birthDate));
    }
    log.debug('Error calculating age from: ', birthDate);
    return null;
  }
  async getAndSaveCustomizedSettings() {
    try {
      var _resp$response;
      const resp = await svs.core.jupiter.callAsync({
        method: 'GET',
        path: '/player/2/customizedsettings'
      });
      if (resp !== null && resp !== void 0 && (_resp$response = resp.response) !== null && _resp$response !== void 0 && (_resp$response = _resp$response.customizedSettings) !== null && _resp$response !== void 0 && _resp$response.properties) {
        const data = this.getUserDataFromCustomizedSettings(resp.response.customizedSettings.properties);
        this.saveToSessionStorage(data);
        return data;
      }
      log.error('Error fetching customized settings, no data');
    } catch (e) {
      log.error('Error fetching customized settings', e);
    }
  }
  deleteStoredUserData() {
    try {
      sessionStorage.removeItem('user');
    } catch (e) {
      log.info("Error trying to remove sessionStorage ".concat(e));
    }
    this.userData = null;
  }
  getUserDataFromCustomizedSettings(data) {
    return {
      birthDate: data.birthDate,
      mobile: data.mobile,
      email: data.email,
      relevantContent: data.relevantContent,
      customerId: data.customerId,
      campaignStatus: data.campaignStatus
    };
  }
}
svs.accountservices.utils.user = new User();

 })(window);